var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ma-3" },
    [
      _c("v-progress-linear", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showGrafico,
            expression: "!showGrafico"
          }
        ],
        attrs: { indeterminate: "", color: "primary" }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showGrafico,
              expression: "showGrafico"
            }
          ]
        },
        [_c("barComp", { ref: "doughnutCompRef", attrs: { height: 280 } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }